import EventBus from "../components/event-bus";
import {store} from "../store/paginationStore";
import {useAssignedVehiclesList} from "../store/AssignedVehiclesList";

export const dataTableMixins =  {

  data() {
    return {
      listCurrentPage: 1,
      perPage: 100,
      requestSend: 0,
      firstReq: 0,
      dropDownPerPage: [100, 500],
      serverParams: {
        columnFilters: {},
        sort: {
          field: 'id',
          type: 'desc',
        },
        page: 1,
        perPage: this.perPage,
        selectedAll: false
      },
      excel: '',
      module: '',
    };
  },
    mounted: function() {
    },
    watch: {
        //change pagination text on change total
        totalRecords:function(total) {
            store.getPagePeriod(store.state.perPage,total);
        }
    },
    methods: {

        onSelectAll(params) {
            if(params.selected) {
              EventBus.$emit('select-all', params.selected);
            } else {
              EventBus.$emit("clear-all-flags", false);
            }
        },

        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },

        onPageChange(params) {

            this.updateParams({page: params.currentPage});
            this.listCurrentPage = params.currentPage;
            this.loadFilters('page-change');
        },

        //default called when page load
        onPerPageChange(params) {
            var self = this;
            this.serverParams.page = 1;
            this.listCurrentPage = params.page;
            this.updateParams({perPage: params.currentPerPage});


            this.$nextTick(function(){
                //fix for call two times request when page load first time
                if (this.requestSend == 0 || this.serverParams.perPage != this.perPage) {

                    if(
                      !(useAssignedVehiclesList().vehicleSpecFiltersLoaded)
                    ){
                      //Loading Default filters and calling loadFilter api as per response
                      this.loadDefaultFilters();
                    }
                    this.requestSend = 1;
                    //set requestSend to 0 so that when user change per page to default
                    if ( this.requestSend == 1 && this.serverParams.perPage != this.perPage ) {
                        this.requestSend = 0;
                    }

                }
            });

        },

        loadDefaultFilters(){
            var self = this;
            self.loading = true;
             $.ajax({
                url: process.env.ROOT_API + "/search-default-filters",
                type: "GET",
                headers: this.ajxHeaders,
                data:{
                    module:self.module
                },
                dataType: "json",
                 success: function (data) {
                    self.loading = false;
                    //remove action column and populate it in filter dropdown
                    var newCol = self.columns.filter(function(item){ return item['field'] != 'action' });

                    if (data.status == 'success') {
                          if ( data.content.default_filter){
                            var loadFilter = 'true';
                            if ( self.$children ) {
                                for( var j=0; j<self.$children.length; j++ ) {

                                    if ( self.$children[j]._name = "<DataTableFilterConfig>") {
                                        if (self.$children[j].fromDashboard != undefined) {
                                            if (self.$children[j].fromDashboard == 'dashboard') {
                                                if (self.$children[j].moduleName == 'bankTransferList' || self.$children[j].moduleName == 'insurancePolicyList') {
                                                    loadFilter = 'false';
                                                }
                                            }else if (self.$children[j].fromDashboard == 'trialbalance') {
                                                if (self.$children[j].moduleName == "generalLedgerReport") {
                                                    loadFilter = 'false';
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            if (loadFilter == 'true'){

                                if (self.routeSelId == undefined || self.routeSelId == ''){
                                  self.serverParams.columnFilters = data.content.default_filter;
                                  EventBus.$emit('default-filter-load', data.content.default_filter);
                                }
                            }
                          }
                          if ( data.sort){
                              if ( self.$children ) {
                                  for( var j=0; j<self.$children.length; j++ ) {

                                      if ( self.$children[j]._name = "<DataTableFilterConfig>") {
                                          self.$children[j].isColumnConfig = true;
                                          self.$children[j].$parent.serverParams.sort = data.sort;
                                          // self.$set(self.$children[j].$parent, 'userColumns', userConfig);
                                      }
                                  }
                              }
                          }
                          EventBus.$emit('all-filter-option', data.content.all_filter);

                          if (data.columns){

                            var jsonArr = JSON.parse(data.columns);
                            if ( data.id != undefined && data.columns[0] != undefined ) {

                              //remove dragable params from array
                              var i = 0;
                              var userConfig = JSON.parse(data.columns,(key, value) => {

                                if ( key == "typeDef" ) {

                                  delete jsonArr[0].typeDef;
                                  i++;
                                  return;
                                }
                                return value;
                              });
                              // self.userColumns = userConfig;
                              if ( self.$children ) {
                                for( var j=0; j<self.$children.length; j++ ) {

                                  if ( self.$children[j]._name = "<DataTableFilterConfig>") {
                                    self.$children[j].isColumnConfig = true;
                                    self.$children[j].parentColumns = JSON.parse(data.columns).filter(function(item){ return item['field'] != 'action' });
                                    self.$children[j].parentColumns = self.$children[j].parentColumns.filter(function(item){ return item['filterable'] != false });//filterable not false
                                    self.$children[j].columnConfigArr = JSON.parse(data.columns);
                                    self.$set(self.$children[j].$parent, 'userColumns', userConfig);
                                  }
                                }
                              }

                            } else {
                              //in case when user not store column configuration
                              if ( self.$children ) {
                                for( var j=0; j<self.$children.length; j++ ) {

                                  if ( self.$children[j]._name = "<DataTableFilterConfig>") {

                                    self.$set(self.$children[j].$parent, 'userColumns', self.$children[j].$parent.columns);
                                    self.$children[j].parentColumns = newCol.filter(function(item){ return item['filterable'] != false });//filterable not false
                                    self.$children[j].columnConfigArr = self.columns;
                                    self.$children[j].isColumnConfig = false;
                                  }
                                }
                              }
                            }

                          }else{
                            if ( self.$children ) {
                              for( var j=0; j<self.$children.length; j++ ) {

                                if ( self.$children[j]._name = "<DataTableFilterConfig>") {

                                  self.$set(self.$children[j].$parent, 'userColumns', self.$children[j].$parent.columns);
                                  self.$children[j].parentColumns = newCol.filter(function(item){ return item['filterable'] != false });//filterable not false
                                  self.$children[j].columnConfigArr = self.columns;
                                  self.$children[j].isColumnConfig = false;
                                }
                              }
                            }
                          }

                    	    self.loadFilters('defaultfilter');

                    } else {
                        EventBus.$emit('all-filter-option', data.content.all_filter);
                        self.loadFilters('load');
                    }

                },
                 error: function (jqXHR, exception) {
                     //incase any error occurs in api then we load list page
                    self.loading = false;
                    self.loadFilters('load');
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");
                            //EventBus.$emit("logged-in", true, "", "");
                            self.$router.push("/");
                        }
                        self.error = jqXHR.responseJSON.message;
                    }
                }
             });

        },

        onSortChange(params) {

            this.updateParams({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
                page:1,
            });

            //reset page
            store.pageChange('reset');
            //check filters
            // if ( this.firstLoad == 1 || filtersValueExists == 1) {
            this.loadFilters('sort');
            // }

        },
        onSortChangeReports(event,flag) {

            var sortType = "desc";
            var sortField = "id";

            var classArr = event.target.className.split(" ");
            $(event.target).parent().find("th").removeClass("sorting-asc sorting-desc");

            if( classArr.indexOf("sorting-asc") == -1 && classArr.indexOf("sorting-desc") == -1 )
            {
                //alert('add asc')
                sortType = 'ASC';
                sortField = event.target.id;
                $(event.target).addClass("sorting-asc");
            } else if ( classArr.indexOf("sorting-asc") > -1 ) {
                //alert('add desc')
                sortField = event.target.id;
                $(event.target).removeClass("sorting-asc");
                $(event.target).addClass("sorting-desc");
            } else if ( classArr.indexOf("sorting-desc") > -1 ) {
                //alert('remove desc')
                sortType = 'ASC';
                sortField = event.target.id;
                $(event.target).removeClass("sorting-desc");
                $(event.target).addClass("sorting-asc");
            }

            this.updateParams({
                sort: {
                    type: sortType,
                    field: sortField,
                },
                page:1,
            });
            //reset page
            store.pageChange('reset');
            //check filters
            // if ( this.firstLoad == 1 || filtersValueExists == 1) {
            this.loadFilters('sort');
            // }

        },

        onColumnFilter(params) {

            var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
            var filters = filtersPr.columnFilters;
            var filtersValueExists = 0;

            Object.keys(filters).forEach(key => {
                if ( filters[key] != "" ) {

                    filters[key] = String(filters[key]).trim();
                    this.serverParams.columnFilters[key] = filters[key];
                    filtersValueExists = 1;
                }

            })

            this.updateParams(params);

            if ( this.firstLoad == 1 || filtersValueExists == 1) {
                this.loadList();
            }
        },
        loadFilters(flag) {

            if ( flag == "clear" || flag == 'clearReport') {
                this.serverParams.columnFilters = [];
                //reset page
                store.pageChange('reset');
            } else if (flag == 'defaultfilter' ) {
                //do nothing here because we already set the perams in default filter api
                if ( this.$children ) {


                    for( var j=0; j<this.$children.length; j++ ) {
                        if ( this.$children[j].id = "dataTableFilterConfig" && this.$children[j].columnFilterArr ) {
                            for ( var i=0; i < this.$children[j].columnFilterArr.length; i++ ) {
                                if ( this.$children[j].columnFilterArr[i].columnId == null ) {
                                    continue;
                                }
                                if ( this.$children[j].columnFilterArr[i].filterOption ) {
                                    if (this.$children[j].columnFilterArr[i].columnId.field == 'location' || this.$children[j].columnFilterArr[i].columnId.field == 'assetType' || this.$children[j].columnFilterArr[i].columnId.field == 'asset_pool' || this.$children[j].columnFilterArr[i].columnId.field == 'pool' || this.$children[j].columnFilterArr[i].columnId.field == 'facility' || this.$children[j].columnFilterArr[i].columnId.field == 'phys_location' || this.$children[j].columnFilterArr[i].columnId.field == 'module' || this.$children[j].columnFilterArr[i].columnId.field == 'equip_type' || this.$children[j].columnFilterArr[i].columnId.field == 'old_location' || this.$children[j].columnFilterArr[i].columnId.field == 'asset_type' || this.$children[j].columnFilterArr[i].columnId.field == 'physical_location' || this.$children[j].columnFilterArr[i].columnId.field == 'name' ){
                                        this.$children[j].columnFilterArr[i].filterOption = [];
                                    }
                                }
                            }
                        }
                        if ( this.$children[j].id = "dataTableFilterConfig" && this.$children[j].columnFilterArr ) {
                            this.duplicateFilterAdjust(this.$children[j].columnFilterArr,'default');
                        }
                    }
                }

            } else {

                //to fix issue when any new filter apply
                if ( flag == "filter" || flag == "adjust" ) {
                    this.listCurrentPage = 1;
                    this.serverParams.page = 1;
                    //reset page
                    store.pageChange('reset');
                }
                if ( this.$children && flag != 'defaultfilter' ) {

                    for( var j=0; j<this.$children.length; j++ ) {
                        if ( this.$children[j].id = "dataTableFilterConfig" && this.$children[j].columnFilterArr ) {
                            if (flag == 'adjust' || flag == 'reportFilter' || flag == 'CPIProofViewList'){
                                //from schedule report
                                if (flag == 'reportFilter') {
                                    for ( var i=0; i < this.$children[j].columnFilterArr.length; i++ ) {
                                        if ( this.$children[j].columnFilterArr[i].columnId == null ) {
                                            continue;
                                        }
                                        if ( this.$children[j].columnFilterArr[i].filterOption ) {
                                            if (this.$children[j].columnFilterArr[i].columnId.field == 'location' || this.$children[j].columnFilterArr[i].columnId.field == 'assetType' || this.$children[j].columnFilterArr[i].columnId.field == 'asset_pool' || this.$children[j].columnFilterArr[i].columnId.field == 'pool' || this.$children[j].columnFilterArr[i].columnId.field == 'facility' || this.$children[j].columnFilterArr[i].columnId.field == 'phys_location' || this.$children[j].columnFilterArr[i].columnId.field == 'module' || this.$children[j].columnFilterArr[i].columnId.field == 'equip_type' || this.$children[j].columnFilterArr[i].columnId.field == 'old_location' || this.$children[j].columnFilterArr[i].columnId.field == 'asset_type' || this.$children[j].columnFilterArr[i].columnId.field == 'physical_location'  || this.$children[j].columnFilterArr[i].columnId.field == 'name'){
                                                this.$children[j].columnFilterArr[i].filterOption = [];
                                            }
                                        }
                                    }
                                }
                                this.duplicateFilterAdjust(this.$children[j].columnFilterArr,'on_filter',j);
                            }

                            var listFilter = [];
                            for ( var i=0; i < this.$children[j].columnFilterArr.length; i++ ) {

                                //to skip if any filter added but column not selected
                                if ( this.$children[j].columnFilterArr[i].columnId == null ) {
                                    continue;
                                }

                                //to skip filter options sent with the request
                                // if ( this.$children[j].columnFilterArr[i].filterOption ) {
                                //   this.$children[j].columnFilterArr[i].filterOption = [];
                                // }

                                if (this.$children[j].columnFilterArr[i].columnId.field == 'location' || this.$children[j].columnFilterArr[i].columnId.field == 'assetType' || this.$children[j].columnFilterArr[i].columnId.field == 'asset_pool' || this.$children[j].columnFilterArr[i].columnId.field == 'pool' || this.$children[j].columnFilterArr[i].columnId.field == 'facility' || this.$children[j].columnFilterArr[i].columnId.field == 'phys_location' || this.$children[j].columnFilterArr[i].columnId.field == 'module' || this.$children[j].columnFilterArr[i].columnId.field == 'equip_type' || this.$children[j].columnFilterArr[i].columnId.field == 'old_location' || this.$children[j].columnFilterArr[i].columnId.field == 'asset_type' || this.$children[j].columnFilterArr[i].columnId.field == 'physical_location'  || this.$children[j].columnFilterArr[i].columnId.field == 'name'){
                                    this.$children[j].columnFilterArr[i].filterOption = [];
                                }

                                var temp = this.$children[j].columnFilterArr[i];
                                //const tempMyObj = Object.assign({}, myObj);

                                if( temp != undefined ){

                                    if( temp.columnId != null && temp.columnId['fpFieldType'] != undefined){

                                        if(temp.columnId['fpFieldType'] == "text" || temp.columnId['fpFieldType'] == "number" || temp.columnId['fpFieldType'] == "integer" || temp.columnId['fpFieldType'] == "year" || temp.columnId['fpFieldType'] == "period"){

                                            if(temp.columnId.field != null && temp.filterType != null && (temp.filterType.value == "IS NULL" || temp.filterType.value == "IS NOT NULL")){
                                                temp.filterValue = "";//value blank as it throw error in backend
                                                listFilter.push(temp);
                                            }
                                            else if(temp.columnId.field != null && (temp.filterType != null && temp.filterType.value != "") && (temp.filterValue != "" || temp.filterValue == 0)){

                                                temp.filterValue = temp.filterValue != undefined ? temp.filterValue.toString().trim(): '';
                                                listFilter.push(temp);
                                            }

                                        }else if(temp.columnId['fpFieldType'] == "option"){

                                            if(temp.columnId.field != null && (temp.filterType != null && temp.filterType.value != "") && (temp.filterOptionValue != null && temp.filterOptionValue.value != "")){
                                                listFilter.push(temp);
                                            }

                                        }else if(temp.columnId['fpFieldType'] == "date" || temp.columnId['fpFieldType'] == "custom_asset_availability" || temp.columnId['fpFieldType'] == "aging_date"){

                                            if(temp.columnId.field != null){

                                                if(temp.filterType != null && temp.filterType.value != ""){

                                                    if(temp.filterType.value == "between"){

                                                        if(temp.filterDateRangeValue != null && (temp.filterDateRangeValue[0] != null && temp.filterDateRangeValue[0] != "") && (temp.filterDateRangeValue[1] != null && temp.filterDateRangeValue[1] != "")){
                                                            listFilter.push(temp);
                                                        }

                                                    }else if (temp.filterType.value == "duration") {
                                                         if(temp.filterValue != null && (temp.filterValue[0] != null && temp.filterValue[0] != "") && (temp.filterValue[1] != null && temp.filterValue[1] != "")){
                                                            listFilter.push(temp);
                                                        }
                                                    }else if (temp.filterType.value == "IS NULL") {

                                                        listFilter.push(temp);
                                                    } else if(temp.filterType.value == "=" && (temp.columnId.field=='start_date' || temp.columnId.field=='end_date')) {
                                                        // temp.filterValue = temp.filterValue.trim();
                                                        listFilter.push(temp);
                                                    }else {

                                                        if(temp.filterDateValue != null && temp.filterDateValue != ""){

                                                            listFilter.push(temp);
                                                        }
                                                    }
                                                }
                                            }

                                        }else if (temp.columnId['fpFieldType'] == "custom_date") {//custom date filter type
                                            if(temp.columnId.field != null){

                                                if(temp.filterType != null && temp.filterType.value != ""){

                                                    if(temp.filterType.value == "between" || temp.filterType.value == "not between"){

                                                        if(temp.filterDateRangeValue != null && (temp.filterDateRangeValue[0] != null && temp.filterDateRangeValue[0] != "") && (temp.filterDateRangeValue[1] != null && temp.filterDateRangeValue[1] != "")){
                                                            listFilter.push(temp);
                                                        }

                                                    }else if (temp.filterType.value == "IS NULL" || temp.filterType.value == "IS NOT NULL") {

                                                        listFilter.push(temp);
                                                    } else if(temp.filterType.value == "=" || temp.filterType.value == "!=" || temp.filterType.value == ">=" || temp.filterType.value == "<=" || temp.filterType.value == "<" || temp.filterType.value == ">") {
                                                        // temp.filterValue = temp.filterValue.trim();
                                                        listFilter.push(temp);
                                                    }else if(temp.filterType.value == "duration") {
                                                        if(temp.filterValue != null && (temp.filterValue[0] != null && temp.filterValue[0] != "") && (temp.filterValue[1] != null && temp.filterValue[1] != "")){
                                                            listFilter.push(temp);
                                                        }
                                                    }else {

                                                        if(temp.filterDateValue != null && temp.filterDateValue != ""){

                                                            listFilter.push(temp);
                                                        }
                                                    }
                                                }
                                            }
                                        }

                                    } else {
                                        listFilter.push(temp);
                                    }
                                }

                            }
                            this.serverParams.columnFilters = listFilter;
                            break;
                        }
                    }
                }

            }
			//alert(flag)
			if ( this.serverParams.stopRequest && this.firstReq == 0 && (flag == "load" || flag == 'defaultfilter') ) {
                this.firstReq = 1;
				return;
			}

            if (flag == 'fuelPriceCustomerList' || flag == 'statementCustomerList') {
                store.pageChange('reset');
                this.loadCustomerList();
            } else if (flag == 'fuelPriceAssetList') {
                store.pageChange('reset');
                this.loadAssetList();
            } else {
                if (flag == 'CPIProofViewList'){
                    this.loadList('filter');
                }
                if (flag != 'reportFilter' && flag != 'filterReport' && flag != 'clearReport' && flag!='loadReport' && flag!='CPIProofViewList' && flag != 'assetFeatureSysPrmList') {
                    this.loadList(flag);
                }

                //reset pagination text in top and bottom pagination
                store.getPagePeriod(store.state.perPage,this.totalRecords);
            }
            //from schedule report form
            if (flag != 'reportFilter') {
                this.loadAllOption(flag);
            }

        },

        loadAllOption:function(flag){
            var self = this;

            if ( this.$children ) {

                for( var j=0; j<this.$children.length; j++ ) {
                    if ( this.$children[j].id = "dataTableFilterConfig" && this.$children[j].columnFilterArr ) {

                        var listFilter = [];
                        for ( var i=0; i < this.$children[j].columnFilterArr.length; i++ ) {

                            //to skip if any filter added but column not selected
                            if ( this.$children[j].columnFilterArr[i].columnId == null ) {
                                continue;
                            }

                            var temp = this.$children[j].columnFilterArr[i];
                            //const tempMyObj = Object.assign({}, myObj);

                            if( temp != undefined ){

                                if( temp.columnId != null && temp.columnId['fpFieldType'] != undefined){

                                    if(temp.columnId['fpFieldType'] == "option"){
                                        if(temp.columnId.field != null && (temp.columnId.field == 'location' || temp.columnId.field == 'phys_location' || temp.columnId.field == 'facility' || temp.columnId.field == 'old_location' || temp.columnId.field == 'physical_location')){
                                            if(temp.filterOption.length == undefined || temp.filterOption.length == 0){
                                                temp.filterOption = this.$children[j].locationArr;
                                            }
                                            listFilter.push(temp);
                                        }
                                        if(temp.columnId.field != null && (temp.columnId.field == 'assetType' || temp.columnId.field == 'equip_type' || temp.columnId.field == 'asset_type')){
                                            if(temp.filterOption.length == undefined || temp.filterOption.length == 0){
                                                temp.filterOption = this.$children[j].vehicleTypeArr;
                                            }
                                            listFilter.push(temp);
                                        }
                                        if(temp.columnId.field != null && (temp.columnId.field == 'asset_pool' || temp.columnId.field == 'pool')){
                                            if(temp.filterOption.length == undefined || temp.filterOption.length == 0){
                                                temp.filterOption = this.$children[j].assetPoolArr;
                                            }
                                            listFilter.push(temp);
                                        }
                                        if(temp.columnId.field != null && this.$children[j].moduleName != "ActivityLogList" && (temp.columnId.field == 'module')){
                                            if(temp.filterOption.length == undefined || temp.filterOption.length == 0){
                                                temp.filterOption = this.$children[j].moduleArr;
                                            }
                                            listFilter.push(temp);
                                        }
                                        if(temp.columnId.field != null && this.$children[j].moduleName == "ActivityLogList" && (temp.columnId.field == 'module')){
                                            if(temp.filterOption.length == undefined || temp.filterOption.length == 0){
                                                temp.filterOption = this.$children[j].activityModuleArr;
                                            }
                                            listFilter.push(temp);
                                        }
                                        if(temp.columnId.field != null && (this.$children[j].moduleName == "PMUnitDetailList" || this.$children[j].moduleName == "PMUnitForecastList") && (temp.columnId.field == 'name')){
                                          if(temp.filterOption.length == undefined || temp.filterOption.length == 0){
                                              temp.filterOption = this.$children[j].programArr;
                                          }
                                          listFilter.push(temp);
                                      }
                                    }

                                } else {
                                    listFilter.push(temp);
                                }
                            }

                        }
                        if (listFilter.length != undefined && listFilter.length > 0){
                            this.serverParams.columnFilters = listFilter;
                            break;
                        }
                    }
                }

            }

        },

        duplicateFilterAdjust:function(filterArr,flag,index){
            var self = this;
            var dupCheckArr = [];
            // for( var j=0; j<filtersArr.length; j++ ) {
            //     var filterArr = filtersArr[j].columnFilterArr;
                if (filterArr && filterArr.length > 0){
                    for(var i=0;i<filterArr.length;i++){
                        if (filterArr[i].columnId){
                            var columnType = filterArr[i].columnId.fpFieldType;

                            if( columnType == "date" || columnType == "aging_date"){
                                if (filterArr[i].filterType != null ) {
                                    if(filterArr[i].filterType.value == 'between'){
                                        var exist = false;

                                        var havInd = dupCheckArr.find(e => e.columnId.field === filterArr[i].columnId.field);

                                        if (havInd != undefined && havInd != null){
                                            var indNew = dupCheckArr.indexOf(havInd);
                                            var valArr = filterArr[indNew].filterDupValue;

                                            valArr.push({value:filterArr[i].filterDateRangeValue,type:filterArr[i].filterType.value});
                                            filterArr[indNew].filterDupValue = valArr;
                                            filterArr[indNew].dupflag = 'true';
                                            // filterArr.splice(i,1);
                                            exist = true;

                                            dupCheckArr.push(filterArr[i]);

                                        }

                                        // var havingObj = dupCheckArr.some(function(e,ind) {
                                        //     if (e.columnId.field === filterArr[i].columnId.field){
                                        //         // console.log(ind);
                                        //         var valArr = [];
                                        //         // valArr.push(e.filterDateRangeValue);
                                        //         // valArr.push(filterArr[i].filterDateRangeValue);
                                        //         valArr.push({value:e.filterDateRangeValue,type:e.filterType.value});
                                        //         valArr.push({value:filterArr[i].filterDateRangeValue,type:filterArr[i].filterType.value});
                                        //         // filterArr[ind].filterOptionValue = valArr;
                                        //         filterArr[ind].filterDupValue = valArr;
                                        //         filterArr[ind].dupflag = 'true';
                                        //         // dupCheckArr.splice(i,1);
                                        //         exist = true;

                                        //         // var valArr = [];
                                        //         // // valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                        //         // valArr.push({value:filterArr[i].filterDateRangeValue,type:filterArr[i].filterType.value});
                                        //         // filterArr[i].filterDupValue = valArr;
                                        //         dupCheckArr.push(filterArr[i]);
                                        //     }
                                        // });
                                        // if (!exist){
                                        //     dupCheckArr.push(filterArr[i]);
                                        // }
                                        if (!exist){
                                            var valArr = [];
                                            // valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                            valArr.push({value:filterArr[i].filterDateRangeValue,type:filterArr[i].filterType.value});
                                            filterArr[i].filterDupValue = valArr;
                                            dupCheckArr.push(filterArr[i]);
                                        }

                                    }else if(filterArr[i].filterType.value == "duration") {
                                        var exist = false;

                                        var havInd = dupCheckArr.find(e => e.columnId.field === filterArr[i].columnId.field);

                                        if (havInd != undefined && havInd != null){
                                            var indNew = dupCheckArr.indexOf(havInd);
                                            var valArr = filterArr[indNew].filterDupValue;

                                            valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                            filterArr[indNew].filterDupValue = valArr;
                                            filterArr[indNew].dupflag = 'true';
                                            // filterArr.splice(i,1);
                                            exist = true;

                                            dupCheckArr.push(filterArr[i]);

                                        }
                                        if (!exist){
                                            var valArr = [];
                                            valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                            filterArr[i].filterDupValue = valArr;
                                            dupCheckArr.push(filterArr[i]);
                                        }
                                    }else{
                                        var exist = false;
                                        // var havingObj = dupCheckArr.some(function(e,ind) {
                                        //     if (e.columnId.field === filterArr[i].columnId.field){
                                        //         // console.log(ind);
                                        //         var valArr = [];
                                        //         valArr.push({value:e.filterDateValue,type:e.filterType.value});
                                        //         valArr.push({value:filterArr[i].filterDateValue,type:filterArr[i].filterType.value});
                                        //         // filterArr[ind].filterOptionValue = valArr;
                                        //         filterArr[ind].filterDupValue = valArr;
                                        //         filterArr[ind].dupflag = 'true';
                                        //         // dupCheckArr.splice(i,1);
                                        //         exist = true;


                                        //         // var valArr = [];
                                        //         // // valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                        //         // valArr.push({value:filterArr[i].filterDateValue,type:filterArr[i].filterType.value});
                                        //         // filterArr[i].filterDupValue = valArr;
                                        //         dupCheckArr.push(filterArr[i]);
                                        //     }
                                        // });

                                        var havInd = dupCheckArr.find(e => e.columnId.field === filterArr[i].columnId.field);

                                        if (havInd != undefined && havInd != null){
                                            var indNew = dupCheckArr.indexOf(havInd);
                                            var valArr = filterArr[indNew].filterDupValue;

                                            valArr.push({value:filterArr[i].filterDateValue,type:filterArr[i].filterType.value});
                                            filterArr[indNew].filterDupValue = valArr;
                                            filterArr[indNew].dupflag = 'true';
                                            // filterArr.splice(i,1);
                                            exist = true;

                                            dupCheckArr.push(filterArr[i]);

                                        }
                                        // if (!exist){
                                        //     dupCheckArr.push(filterArr[i]);
                                        // }
                                        if (!exist){
                                            var valArr = [];
                                            // valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                            valArr.push({value:filterArr[i].filterDateValue,type:filterArr[i].filterType.value});
                                            filterArr[i].filterDupValue = valArr;
                                            dupCheckArr.push(filterArr[i]);
                                        }
                                        // dupCheckArr.push({text:filterArr[i].columnId.field,value:filterArr[i].filterDateValue,index:i});
                                    }
                                }

                            }
                            if( columnType == "option" ){
                                if (filterArr[i].filterType != null ) {

                                    var exist = false;
                                    var havInd = dupCheckArr.find(e => e.columnId.field === filterArr[i].columnId.field);

                                    if (havInd != undefined && havInd != null){
                                        var indNew = dupCheckArr.indexOf(havInd);
                                        var valArr = filterArr[indNew].filterDupValue;
                                        if (filterArr[i].columnId.field == 'location' || filterArr[i].columnId.field == 'assetType' || filterArr[i].columnId.field == 'asset_pool' || filterArr[i].columnId.field == 'pool' || filterArr[i].columnId.field == 'facility' || filterArr[i].columnId.field == 'phys_location' || filterArr[i].columnId.field == 'module' || filterArr[i].columnId.field == 'equip_type' || filterArr[i].columnId.field == 'old_location' || filterArr[i].columnId.field == 'asset_type' || filterArr[i].columnId.field == 'name'){
                                            filterArr[i].filterOption = [];
                                        }
                                        valArr.push({value:filterArr[i].filterOptionValue,type:filterArr[i].filterType.value});
                                        // updating the filterDupValue to the filterArr
                                        filterArr[i].filterDupValue = valArr;
                                        filterArr[i].dupflag = 'true';

                                        // filterArr[indNew].filterDupValue = valArr;
                                        // filterArr[indNew].dupflag = 'true';
                                        // filterArr.splice(i,1);
                                        exist = true;

                                        dupCheckArr.push(filterArr[i]);

                                    }

                                    // var havingObj = dupCheckArr.some(function(e,ind) {
                                    //     if (e.columnId.field === filterArr[i].columnId.field){
                                    //         // console.log(ind);
                                    //         var valArr = [];
                                    //         // valArr.push(e.filterOptionValue);
                                    //         // valArr.push(filterArr[i].filterOptionValue);
                                    //         valArr.push({value:e.filterOptionValue,type:e.filterType.value});
                                    //         valArr.push({value:filterArr[i].filterOptionValue,type:filterArr[i].filterType.value});
                                    //         // filterArr[ind].filterOptionValue = valArr;
                                    //         filterArr[ind].filterDupValue = valArr;
                                    //         filterArr[ind].dupflag = 'true';
                                    //         // dupCheckArr.splice(i,1);
                                    //         exist = true;

                                    //         // var valArr = [];
                                    //         // valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                    //         // valArr.push({value:filterArr[i].filterOptionValue,type:filterArr[i].filterType.value});
                                    //         // filterArr[i].filterDupValue = valArr;
                                    //         dupCheckArr.push(filterArr[i]);
                                    //     }
                                    // });
                                    // if (!exist){
                                    //     dupCheckArr.push(filterArr[i]);
                                    // }
                                    if (!exist){
                                        var valArr = [];
                                        // valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                        valArr.push({value:filterArr[i].filterOptionValue,type:filterArr[i].filterType.value});
                                        filterArr[i].filterDupValue = valArr;
                                        dupCheckArr.push(filterArr[i]);
                                    }
                                }
                            }
                            if( columnType == "text" || columnType == "integer" || columnType == 'year' || columnType == 'period'){

                                if (filterArr[i].filterType != null ) {

                                    var exist = false;
                                    var havInd = dupCheckArr.find(e => e.columnId.field === filterArr[i].columnId.field);

                                    if (havInd != undefined && havInd != null){
                                        var indNew = dupCheckArr.indexOf(havInd);
                                        var valArr = filterArr[indNew].filterDupValue;
                                        // valArr.push(e.filterValue);
                                        // valArr.push(filterArr[i].filterValue);
                                        // valArr.push({value:havInd.filterValue,type:havInd.filterType.value});
                                        valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                        filterArr[indNew].filterDupValue = valArr;
                                        filterArr[indNew].dupflag = 'true';
                                        // filterArr.splice(i,1);
                                        exist = true;

                                        // var valArr = [];
                                        // valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                        // valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                        // filterArr[i].filterDupValue = valArr;
                                        dupCheckArr.push(filterArr[i]);

                                    }
                                    // var havingObj = dupCheckArr.some(function(e,ind) {
                                    //     alert(ind);
                                    //     if (e.columnId.field === filterArr[i].columnId.field){
                                    //         var valArr = [];
                                    //         // valArr.push(e.filterValue);
                                    //         // valArr.push(filterArr[i].filterValue);
                                    //         valArr.push({value:e.filterValue,type:e.filterType.value});
                                    //         valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                    //         filterArr[ind].filterDupValue = valArr;
                                    //         filterArr[ind].dupflag = 'true';
                                    //         // filterArr.splice(i,1);
                                    //         exist = true;

                                    //         // var valArr = [];
                                    //         // valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                    //         // valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                    //         // filterArr[i].filterDupValue = valArr;
                                    //         dupCheckArr.push(filterArr[i]);
                                    //     }else{
                                    //         // var valArr = [];
                                    //         // // valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                    //         // valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                    //         // filterArr[i].filterDupValue = valArr;
                                    //         // dupCheckArr.push(filterArr[i]);
                                    //     }
                                    // });

                                    if (!exist){
                                        var valArr = [];
                                        // valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                        valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                        filterArr[i].filterDupValue = valArr;
                                        dupCheckArr.push(filterArr[i]);
                                    }
                                }
                            }
                            //custom date filter type
                            if (columnType == "custom_date") {
                                if (filterArr[i].filterType != null ) {
                                    if(filterArr[i].filterType.value == 'between' || filterArr[i].filterType.value == 'not between'){
                                        var exist = false;

                                        var havInd = dupCheckArr.find(e => e.columnId.field === filterArr[i].columnId.field);

                                        if (havInd != undefined && havInd != null){
                                            var indNew = dupCheckArr.indexOf(havInd);
                                            var valArr = filterArr[indNew].filterDupValue;

                                            valArr.push({value:filterArr[i].filterDateRangeValue,type:filterArr[i].filterType.value});
                                            filterArr[indNew].filterDupValue = valArr;
                                            filterArr[indNew].dupflag = 'true';
                                            // filterArr.splice(i,1);
                                            exist = true;

                                            dupCheckArr.push(filterArr[i]);

                                        }

                                        if (!exist){
                                            var valArr = [];
                                            // valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                            valArr.push({value:filterArr[i].filterDateRangeValue,type:filterArr[i].filterType.value});
                                            filterArr[i].filterDupValue = valArr;
                                            dupCheckArr.push(filterArr[i]);
                                        }
                                    }else if(filterArr[i].filterType.value == 'IS NULL' || filterArr[i].filterType.value == 'IS NOT NULL'){
                                        var exist = false;

                                        var havInd = dupCheckArr.find(e => e.columnId.field === filterArr[i].columnId.field);

                                        if (havInd != undefined && havInd != null){
                                            var indNew = dupCheckArr.indexOf(havInd);
                                            var valArr = filterArr[indNew].filterDupValue;

                                            valArr.push({value:filterArr[i].filterDateValue,type:filterArr[i].filterType.value});
                                            filterArr[indNew].filterDupValue = valArr;
                                            filterArr[indNew].dupflag = 'true';
                                            // filterArr.splice(i,1);
                                            exist = true;

                                            dupCheckArr.push(filterArr[i]);

                                        }

                                        if (!exist){
                                            var valArr = [];
                                            // valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                            valArr.push({value:filterArr[i].filterDateValue,type:filterArr[i].filterType.value});
                                            filterArr[i].filterDupValue = valArr;
                                            dupCheckArr.push(filterArr[i]);
                                        }
                                    }else if(filterArr[i].filterType.value == "duration") {
                                        var exist = false;

                                        var havInd = dupCheckArr.find(e => e.columnId.field === filterArr[i].columnId.field);

                                        if (havInd != undefined && havInd != null){
                                            var indNew = dupCheckArr.indexOf(havInd);
                                            var valArr = filterArr[indNew].filterDupValue;

                                            valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                            filterArr[indNew].filterDupValue = valArr;
                                            filterArr[indNew].dupflag = 'true';
                                            // filterArr.splice(i,1);
                                            exist = true;

                                            dupCheckArr.push(filterArr[i]);

                                        }
                                        if (!exist){
                                            var valArr = [];
                                            valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                            filterArr[i].filterDupValue = valArr;
                                            dupCheckArr.push(filterArr[i]);
                                        }
                                    }else{
                                        var exist = false;
                                        var havInd = dupCheckArr.find(e => e.columnId.field === filterArr[i].columnId.field);

                                        if (havInd != undefined && havInd != null){
                                            var indNew = dupCheckArr.indexOf(havInd);
                                            var valArr = filterArr[indNew].filterDupValue;
                                            valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                            filterArr[indNew].filterDupValue = valArr;
                                            filterArr[indNew].dupflag = 'true';
                                            exist = true;

                                            dupCheckArr.push(filterArr[i]);

                                        }
                                        if (!exist){
                                            var valArr = [];
                                            valArr.push({value:filterArr[i].filterValue,type:filterArr[i].filterType.value});
                                            filterArr[i].filterDupValue = valArr;
                                            dupCheckArr.push(filterArr[i]);
                                        }
                                    }
                                }
                            }
                        }

                    }
                    if (flag == 'default'){
                        this.serverParams.columnFilters = dupCheckArr;
                    }else{
                        for( var j=0; j<this.$children.length; j++ ) {

                            if ( this.$children[j].id = "dataTableFilterConfig" && this.$children[j].columnFilterArr ) {
                                // this.duplicateFilterAdjust(this.$children[j].columnFilterArr,'default');

                                if (this.$children[j].id = "dataTableFilterConfig" && this.$children[j].fromSchedule) {
                                    //if from schedule report and no filters added prevent blank array scenario
                                    if (this.$children[j].fromSchedule != undefined && this.$children[j].fromSchedule == 'schedule-report') {
                                        if (dupCheckArr.length < 1) {
                                            dupCheckArr = [{
                                                columnId:null,
                                                isColumnDisable:false,
                                                filterValue: null,
                                                filterDateValue: null,
                                                filterDateRangeValue: null,
                                                filterOptionValue: null,
                                                filterType: null,
                                            }];
                                        }
                                    }
                                }
                                this.$children[j].columnFilterArr = dupCheckArr;

                            }
                        }
                    }
                }
            // }
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/dataTableMixins.js